import { createRecipe } from './runtime.js';

const gridSpanConfig = {"name":"gridSpan"}

export const gridSpan = /* @__PURE__ */ createRecipe(gridSpanConfig)